const firebaseConfig = {
  apiKey: "AIzaSyBV1o8iW_TmejeDlqPjy2Q5Q89Z9M8QwzE",

  authDomain: "iman-xpress.firebaseapp.com",

  projectId: "iman-xpress",

  storageBucket: "iman-xpress.appspot.com",

  messagingSenderId: "1079505892162",

  appId: "1:1079505892162:web:eb6e930f9029e20d0e4edb",

  measurementId: "G-NBH3205DYH",
};

export default firebaseConfig;
